import useAppDispatch from '../../hooks/useAppDispatch';
import { useTranslation } from '../../hooks/useTranslation';
import type { IconId } from '../icon/icons';
import ChatClickableButton from './ChatClickableButton';
import './AssistantChatMessageButton.less';
import type { AssistantChatMessageContent } from '@public-api-contracts/models/chat/ChatMessage';

export type AssistantChatMessageButtonProps = {
    content: Extract<AssistantChatMessageContent, { contentType: 'button' }>;
};

const AssistantChatMessageButton = ({
    content
}: AssistantChatMessageButtonProps) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const buttonClickHandler = () => {
        if (content.contentType !== 'button') {
            return;
        }
        switch (content.featureType) {
            case 'product-search-similar':
                void dispatch.featureState.startFeature({
                    featureType: 'product-search-similar',
                    similarToProductIds: content.contextualProductIds
                });
                break;
            case 'product-search-combinations':
                void dispatch.featureState.startFeature({
                    featureType: 'product-search-combinations',
                    combinationWithProductIds: content.contextualProductIds
                });
                break;
            case 'product-mix-and-match':
                void dispatch.featureState.startFeature({
                    featureType: 'product-mix-and-match',
                    productId: content.contextualProductIds[0] ?? ''
                });
                break;
            default:
                break;
        }
    };

    const getButtonIconId = (): IconId => {
        if (content.contentType !== 'button') {
            return 'star';
        }
        switch (content.featureType) {
            case 'product-search-similar':
                return 'similar';
            case 'product-search-combinations':
                return 'join';
            case 'product-mix-and-match':
                return 'outfit';
            default:
                return 'star';
        }
    };

    const getButtonText = (): string => {
        if (content.contentType !== 'button') {
            return '';
        }
        switch (content.featureType) {
            case 'product-search-similar':
                return t('SUGGESTED_ALTERNATIVE_SEARCH_SIMILAR_BUTTON_LABEL');
            case 'product-search-combinations':
                return t(
                    'SUGGESTED_ALTERNATIVE_SEARCH_COMBINATIONS_BUTTON_LABEL'
                );
            case 'product-mix-and-match':
                return t('SUGGESTED_ALTERNATIVE_MIX_AND_MATCH_BUTTON_LABEL');
            default:
                return '';
        }
    };

    return (
        <ChatClickableButton
            startIconId={getButtonIconId()}
            text={getButtonText()}
            onClick={buttonClickHandler}
        />
    );
};

export default AssistantChatMessageButton;
